import React from 'react';
import FormWrapper from '../../../common/formComponents/FormWrapper/FormWrapper';
import TextField from '../../../common/formComponents/TextField/TextField';
import TextAreaField from '../../../common/formComponents/TextAreaField/TextAreaField';
import { getInputOptions } from '../utils/getInputOptions';

const OneFieldForm = ({
  fieldType = 'text',
  label,
  name,
  initialValue,
  requiredErrMsg,
  validationTypes = [],
  numberComparison = false,
  form,
  inputProps,
}) => {
  const props = {
    label,
    name,
    form,
    inputProps,
    options: getInputOptions({
      initialValue: initialValue,
      requiredErrMsg,
      validationTypes: ['notEqualToInitVal', ...validationTypes],
      numberComparison,
    }),
  };

  return (
    <FormWrapper>
      {fieldType === 'text' && <TextField {...props} />}
      {fieldType === 'area' && <TextAreaField {...props} />}
    </FormWrapper>
  );
};

export default OneFieldForm;
